import { render } from "./code-verification.vue?vue&type=template&id=bc739e1c&scoped=true"
import script from "./code-verification.vue?vue&type=script&lang=ts"
export * from "./code-verification.vue?vue&type=script&lang=ts"

import "./code-verification.vue?vue&type=style&index=0&id=bc739e1c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bc739e1c"

export default script